import { cloudApiHosts, isCloudDevDeploy } from '../../../../config/cloud-deploy-hosts'
import {
  buildDemoSchedulePath,
  buildDemoReschedulePath,
  type DemoBookingLinkParams,
} from '../../../../config/demo-links'

// Environment configuration for ServiceFlow Pro Admin App
interface EnvironmentConfig {
  apiBaseUrl: string
  environment: string
  isProduction: boolean
  isDevelopment: boolean
}

const getEnvironmentConfig = (): EnvironmentConfig => {
  const isProduction = (import.meta as any).env?.PROD || false
  const isDevelopment = (import.meta as any).env?.DEV || true
  
  // Debug logging
  console.log('🔍 Admin Environment Debug:', {
    PROD: (import.meta as any).env?.PROD,
    DEV: (import.meta as any).env?.DEV,
    MODE: (import.meta as any).env?.MODE,
    VITE_API_URL: (import.meta as any).env?.VITE_API_URL,
    isProduction,
    isDevelopment
  })
  
  if (isProduction) {
    const hosts = cloudApiHosts()
    console.log(isCloudDevDeploy() ? '🚀 Admin using CLOUD DEV configuration' : '🚀 Admin using PRODUCTION configuration')
    return {
      apiBaseUrl: (import.meta as { env?: { VITE_API_URL?: string } }).env?.VITE_API_URL || hosts.api,
      environment: isCloudDevDeploy() ? 'cloud-dev' : 'production',
      isProduction: true,
      isDevelopment: false
    }
  }
  
  // Development configuration
  console.log('🛠️ Admin using DEVELOPMENT configuration')
  return {
    apiBaseUrl: (import.meta as any).env?.VITE_API_URL || 'http://localhost:3001',
    environment: 'development',
    isProduction: false,
    isDevelopment: true
  }
}

export const env = getEnvironmentConfig()

export function getWebPublicOrigin(): string {
  const isProduction = (import.meta as { env?: { PROD?: boolean; VITE_WEB_URL?: string } }).env?.PROD || false

  if (isProduction) {
    return cloudApiHosts().web
  }

  return (import.meta as { env?: { VITE_WEB_URL?: string } }).env?.VITE_WEB_URL || 'http://localhost:5173'
}

export function buildDemoRescheduleUrl(ticketNumber: string, requesterEmail: string): string {
  return `${getWebPublicOrigin()}${buildDemoReschedulePath(ticketNumber, requesterEmail)}`
}

export function buildDemoScheduleUrl(ticketNumber: string, requesterEmail: string): string {
  return `${getWebPublicOrigin()}${buildDemoSchedulePath(ticketNumber, requesterEmail)}`
}

export function buildDemoBookingUrl(params: DemoBookingLinkParams): string {
  return buildDemoScheduleUrl(params.ticketNumber, params.requesterEmail)
}

export default env
